<template>
    <div class="description--group" :class="{ 'description--grid': grid }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'DescriptionGroup',
    props: [
        'grid',
    ],
};
</script>

